export default __webpack_public_path__ + "static/media/nossas_unidades_6.63911c9e.webp";